import * as Yup from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';

const customPhoneValidator = (phoneNumber) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber);
    return phoneUtil.isValidNumber(number);
  } catch (err) {
    return false;
  }
};
// export const AddClientFormValidationSchema = Yup.object().shape({
//   companyName: Yup.string().required('Company Name is required.'),
//   industry: Yup.string().required('Please select an Industry'),
//   contactPerson: Yup.object().shape({
//     name: Yup.string().required('Contact Person is required'),
//     designation: Yup.string().required('Designation is required'),
//     phoneNumber: Yup.string().test("Phone number is not valid", customPhoneValidator)
//       .required("A valid phone number is required"),
//     emailId: Yup.string().email("Please provide a valid email id").required('Contact Person Email Id is required'),
//   }),
//   companyAddrPinCode: Yup.number()
//     .min(100000, 'Pin Code should be a 6 digit number.')
//     .max(999999, 'Pin Code should be a 6 digit number.')
//     .required('PIN Code is required'),
//   gstAddressPinCode: Yup.number()
//     .when('gstAddressDiffFromCompanyAddress', {
//       is: 'YES',
//       then: Yup.number()
//         .min(100000, 'Pin Code should be a 6 digit number.')
//         .max(999999, 'Pin Code should be a 6 digit number.')
//         .required('PIN Code is required'),
//     })
//     .nullable(),
//   address: Yup.string().required('Address is required'),
//   gstAddress: Yup.string()
//     .when('gstAddressDiffFromCompanyAddress', {
//       is: 'YES',
//       then: Yup.string().required('Address is required'),
//     })
//     .nullable(),
//   gstin: Yup.string().required('GST Number is required'),
//   // subscriptions: Yup.array(Yup.object().shape({
//   //   paymentType: Yup.string().required('Payment Type is required'),
//   //   subscriptionType: Yup.string().required('Subscription Type is required'),
//   //   paymentDate:Yup.string().required('Subscription Date is required')
//   // }))
//   subscriptions: Yup.array(Yup.object().shape({
//   paymentType: Yup.string().required('Payment Type is required'),
//   subscriptionId: Yup.number()
//     .required('Subscription Type is required'),
//   paymentDate: Yup.string().required('Subscription Date is required')
// }))

// });

export const AddClientFormValidationSchema = Yup.object().shape({
  companyName: Yup.string().required('Company Name is required.'),

  industry: Yup.string().required('Please select an Industry'),

  contactPerson: Yup.object().when('$isEditMode', {
    is: true,
    then: Yup.object().notRequired(),
    otherwise: Yup.object().shape({
      name: Yup.string().required('Contact Person is required'),
      designation: Yup.string().required('Designation is required'),

      phoneNumber: Yup.string()
        .required("A valid phone number is required")
        .test(
          "phone-test",
          "Phone number is not valid",
          value => customPhoneValidator(value)
        ),

      emailId: Yup.string()
        .email("Please provide a valid email id")
        .required('Contact Person Email Id is required'),
    }),
  }),


  companyAddrPinCode: Yup.string()
    .matches(/^\d{6}$/, 'Pin Code should be a 6 digit number.')
    .required('PIN Code is required'),

  gstAddressPinCode: Yup.string()
    .when('gstAddressDiffFromCompanyAddress', {
      is: 'YES',
      then: Yup.string()
        .matches(/^\d{6}$/, 'Pin Code should be a 6 digit number.')
        .required('PIN Code is required'),
    })
    .nullable(),

  address: Yup.string().required('Address is required'),

  gstAddress: Yup.string()
    .when('gstAddressDiffFromCompanyAddress', {
      is: 'YES',
      then: Yup.string().required('Address is required'),
    })
    .nullable(),

  gstin: Yup.string().required('GST Number is required'),

});